// extracted by mini-css-extract-plugin
var _1 = "ResetPassword-module__content___lPOHE";
export { _1 as "content" }
